var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SubmitButton',{attrs:{"loading":_vm.loading,"icon":"fa fa-file-excel","text":_vm.$t('ui.' + _vm.btnTxt),"type":"button","variant":"info","size":"sm"},on:{"click":function($event){return _vm.tableToExcel()}}})}
var staticRenderFns = []

export { render, staticRenderFns }